<template>
  <div class="contact">
<!--    <div class="banner">-->
<!--      <div class="text">-->
<!--        <img src="../assets/images/contact/about-bg(案例.jpg">-->
<!--        <div class="content">-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->




<!-- <div class="title">
  <h2>华特简介</h2>

</div>

<div class="ht-vContent">
  <div class="ht-video" >
    <video src="../assets/images/contact/华特视频.mp4" width="580" height="365" preload="auto" controls="controls"></video>
  </div>
  <div class="conjs">
  <p>
    华特信息技术有限公司
    <br>

  </p>
  </div>
</div>

 -->
    <div class="contactUs">
      <div class="dxal">
        <p class="dxal_title">  联系我们
          <i></i>
        </p>
      </div>
        <ul class="contact_list">
            <li v-for="item in article_list" :key="item.id">
                <h1>{{item.title}}</h1>
                <ul class="contact_list_dh">
                    <li>
                        <p class="contact_list_dh_dz">地址：</p>
                        <p class="contact_list_nr">{{item.desc}}</p>
                    </li>
                    <li>
                        <p class="contact_list_dh_dz">负责人：</p>
                        <p class="contact_list_nr">{{item.origin}}</p>
                    </li>
                    <li>
                        <p class="contact_list_dh_dz">电话：</p>
                        <p class="contact_list_nr">{{item.origin_url}}</p>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        companyName: "",
        subject: "",
        message: "",
      },
      positionInfo: {},
        info: "",
        article_list: [],
    };
  },
    created() {
        this.getarticlelist();
    },
  mounted() {
    // this.initMap();
  },
  methods: {
      getarticlelist() {
          let self = this;
          var url = "index/article_list?cate_id=11";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.article_list = res.data.data.list;
          })
      },
      getpagesshow() {
          let self = this;
          var url = "index/pages_show?pages_id=4";
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              self.info = res.data.data.info.content;
          })
      },
    submit() { },
    // initMap() {
    //   var map = new AMap.Map("container", {
    //     zoom: 11, //级别
    //     center: [114.27424034722135, 30.591635156078656], //中心点坐标
    //     viewMode: "3D", //使用3D视图
    //     zoom: "18",
    //   });
    //   var marker = new AMap.Marker({
    //     position: new AMap.LngLat(114.27424034722135, 30.591635156078656), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
    //     title: "湖北华特",
    //   });
    //   map.add(marker);
    //   marker.setLabel({
    //     offset: new AMap.Pixel(0, -15), //设置文本标注偏移量
    //     content:
    //       "<div class='info'>公司名称：湖北华特信息技术有限公司<br>联系电话：027-85800637</div>", //设置文本标注内容
    //     direction: "top", //设置文本标注方位
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>
.contact {

  width: 192rem;

  .title{
    width: 100%;
    position: relative;
    text-align: center;
    display: block;
    padding: 70px 0 35px;
    overflow: hidden;
  }


  .title h2{
    font-size: 34px;
    color: #1F0A14;
    display: block;
    line-height: 35px;
    font-weight: 400;
  }

  .ht-vContent{

    width: 1340px;
    margin: 0 auto;
    position: relative;
    overflow: hidden;
    padding-bottom: 80px;
    .ht-video{
      width: 580px;
      height: 365px;
      display: block;
      float: left;
      background: #0B0B0B;
    }
    .conjs{

    width: 700px;
    float: right;
    display: block;
    font-size: 15px;
    line-height: 28px;
    color: #5B5B5B;
    text-align: justify;

  }
  }


  // .banner {
  //   display: flex;
  //   flex-direction: row;
  //   justify-content: flex-start;
  //   background-color: #f5fdff;

  //   .text {
  //     width: 175rem;
  //     //padding: 6rem 0 6rem 21rem;
  //     text-align: left;

  //     .title {
  //       font-size: 4.6rem;
  //       color: #0b54e7;
  //       font-weight: 500;
  //     }

  //     .subtitle {
  //       font-size: 4.5rem;
  //       color: black;
  //       font-weight: 500;
  //       //width: 60rem;
  //       padding: 2rem 0;
  //     }

  //     .content {
  //       font-size: 1.8rem;
  //       color: #717571;
  //       font-weight: 400;
  //       width: 65rem;
  //       line-height: 1.5;
  //     }
  //   }

  // }

  .contactUs {
    li{
      list-style: none;
    }
    width: 170rem;
    margin: 0 auto;

    .dxal {
      width: 100%;

      .dxal_title {
        border-bottom: 1px solid #e1e1e1;
        width: 200px;
        font-size: 40px;
        text-align: center;
        margin: 0 auto;
        position: relative;
        padding: 10px 0;

      }

      .dxal_title i {
        width: 50px;
        display: inline-block;
        height: 3px;
        background: #3d8bed;
        position: absolute;
        bottom: -2px;
        left: 78px;
        margin: 0 auto;
      }
    }

    .contact_list{
      display: -webkit-flex;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 50px 0 0 0;
    }
    .contact_list li h1{
      margin: 0px;
      font-size: 2.5rem;
      color: #fff;
      padding: 20px 10px 20px 50px;
      background: #0d79be;
    }

    .contact_list > li{
      width: 46%;
      background: #fff;
      margin-right: 80px;
      margin-bottom: 5rem;
      display: -webkit-flex;
      flex-direction: column;
      display: flex;
      border: 1px solid #e1e1e1;
      text-align: left;
      margin-right: 0;
    }
    .contact_list_dh{
      margin-top: 10px;
      font-size: 2.2rem;
      color: #666666;
    }
    .contact_list_dh > li{
      display: -webkit-flex;
      display: flex;
      justify-content: flex-start;
      line-height: 1rem;
    }

    .contact_list_dh_dz{
      width: 15%;
    }
    .contact_list_nr{
      float:left;
      margin-right:10px;
      width: 100%;
    }

  }


  //.contactUs {
  //  width: 140rem;
  //  margin: 0 auto;
  //
  //  .topTitle {
  //    padding: 4rem 0;
  //    text-align: left;
  //
  //    div:nth-child(1) {
  //      font-size: 3.6rem;
  //      font-weight: 500;
  //      color: #0b54e7;
  //    }
  //
  //    div:nth-child(2) {
  //      font-size: 2.2rem;
  //      font-weight: 500;
  //      color: black;
  //      padding: 1rem 0;
  //    }
  //
  //    div:last-child {
  //      font-size: 1.4rem;
  //      font-weight: 400;
  //      color: #717571;
  //      line-height: 1.5;
  //      width: 80rem;
  //    }
  //
  //  }
  //
  //  .bottom {
  //
  //
  //    display: flex;
  //    flex-direction: row;
  //    justify-content: flex-start;
  //
  //    .left {
  //      width: 50rem;
  //
  //      .item {
  //        margin-bottom: 3rem;
  //        display: flex;
  //        flex-direction: row;
  //        justify-content: flex-start;
  //
  //        .itemLeft {
  //          width: 7rem;
  //          height: 7rem;
  //          line-height: 7rem;
  //          text-align: center;
  //          border: 0.2rem solid #ddd;
  //          border-radius: 0.5rem;
  //          margin-right: 3rem;
  //
  //          .img1 {
  //            width: 5rem;
  //            height: 5rem;
  //            background: url("../assets/images/contact/icon1.png") no-repeat 0 0;
  //            background-size: 100% 300%;
  //            margin: 1rem;
  //          }
  //
  //          .img2 {
  //            width: 5rem;
  //            height: 5rem;
  //            background: url("../assets/images/contact/icon1.png") no-repeat 0 -5rem;
  //            background-size: 100% 300%;
  //            margin: 1rem;
  //          }
  //
  //          .img3 {
  //            width: 5rem;
  //            height: 5rem;
  //            background: url("../assets/images/contact/icon1.png") no-repeat 0 -10rem;
  //            background-size: 100% 300%;
  //            margin: 1rem;
  //          }
  //        }
  //
  //        .itemRight {
  //          text-align: left;
  //
  //          .itemTitle {
  //            font-size: 2rem;
  //            font-weight: 500;
  //            color: black;
  //          }
  //
  //          .name {
  //            font-size: 1.4rem;
  //            color: #717571;
  //            padding: 0.6rem 0;
  //          }
  //
  //          .phone {
  //            font-size: 1.4rem;
  //            color: #717571;
  //          }
  //        }
  //      }
  //    }
  //
  //    .right {
  //      width: 90rem;
  //      padding: 0 5rem 5rem 5rem;
  //
  //      .formItem {
  //        display: flex;
  //        flex-direction: row;
  //        justify-content: flex-start;
  //      }
  //    }
  //  }
  //}
}
@media screen and (max-width: 750px) {
  .contact {

width: 192rem;

.banner {
  display: flex;

  .text {


    .title {
      font-size: 4.6rem;
      color: #0b54e7;
      font-weight: 500;
    }

    .subtitle {
      font-size: 4.5rem;
      color: black;
      font-weight: 500;
      //width: 60rem;
      padding: 2rem 0;
    }

    .content {
      font-size: 1.8rem;
      color: #717571;
      font-weight: 400;
      width: 65rem;
      line-height: 1.5;
    }
  }

}

.contactUs {
  li{
    list-style: none;
  }
  width: 170rem;
  margin: 0 auto;

  .dxal {
    width: 100%;

    .dxal_title {
      border-bottom: 1px solid #e1e1e1;
      width: 50rem;
      font-size: 10rem;
      text-align: center;
      margin: 0 auto;
      position: relative;
      padding: 10px 0;

    }

    .dxal_title i {
      display: none;
    }
  }

  .contact_list{
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 20rem 0 0 0;
  }
  .contact_list li h1{
    margin: 0px;
    font-size: 9rem;
    color: #fff;
    padding: 10px 10px 10px 20px;
    background: #0d79be;
  }

  .contact_list > li{
    width: 100%;
    background: #fff;
    margin-right: 80px;
    margin-bottom: 8rem;
    display: -webkit-flex;
    flex-direction: column;
    display: flex;
    border: 1px solid #e1e1e1;
    text-align: left;
    margin-right: 0;
  }
  .contact_list_dh{
    margin-top: 10px;
    font-size: 2.2rem;
    padding: 10px 20px;
    color: #666666;
  }
  .contact_list_dh > li{
    display: -webkit-flex;
    display: flex;
    justify-content: flex-start;
    font-size: 8rem;
    line-height: 9rem !important;
  }

  .contact_list_dh_dz{
    width: 30%;
  }
  .contact_list_nr{
    float:left;
    margin-right:10px;
    width: 100%;
  }

}

}

}

</style>
<style lang="scss">
.contact {
  .formItem {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }

    .el-input__inner {
      width: 41rem;
    }

    .el-input:first-child {
      margin-right: 2rem;
    }
  }

  .btn {
    .el-form-item__content {
      text-align: right;
    }
  }

  .el-textarea__inner {
    height: 13rem;
  }

  .amap-marker-label {
    border: 0;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 0.5rem;
    padding: 1rem;
    line-height: 1.5;
  }

  .info {
    position: relative;
    top: 0;
    right: 0;
    min-width: 0;
    font-size: 1.4rem;
    color: #fff;
  }
}
</style>
